// eslint-disable-next-line
import { UserLayout, BasicLayout, BlankLayout, RouteView } from '@/layouts'

// const RouteView = {
//   name: 'RouteView',
//   render: (h) => h('router-view')
// }

export const asyncRouterMap = [
  {
    path: '/',
    name: 'indexTemp',
    component: BasicLayout,
    meta: { title: '工作台', keepAlive: true },
    redirect: '/dashboard/workplace',
    children: [
      // {
      // path: '/dashboard/workplace',
      // name: 'WorkPlacePage',
      // component: () => import('@/views/dashboard/Workplace'),
      // meta: { title: '工作台', keepAlive: true, icon: '#icon-lsmy-shouye' }
      // },
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/workplace',
        component: RouteView,
        meta: { title: '工作台', keepAlive: true, icon: '#icon-lsmy-shouye' },
        children: [{
          path: 'workplace',
          name: 'WorkPlacePage',
          component: () => import('@/views/dashboard/Workplace'),
          meta: { title: '工作台', keepAlive: true },
          hidden: true
        }]
      },
      {
        path: '/mom-subapp',
        name: 'MomSubapp',
        component: () => import('@/views/subapps/MomSubapp'),
        meta: { title: 'MOM子应用', keepAlive: true, icon: 'control' }
      },
      {
      path: '/system',
      name: 'system',
      redirect: '/system/user',
      component: RouteView,
      meta: { title: '系统管理', keepAlive: true, icon: 'control' },
      children: [
        // {
        //   path: '/system/user',
        //   name: 'User',
        //   component: () => import('@/views/system/user'),
        //   meta: { title: '用户管理', keepAlive: false }
        // },
        // {
        //   path: '/system/role',
        //   name: 'Role',
        //   component: () => import('@/views/system/role'),
        //   meta: { title: '角色管理', keepAlive: true }
        // }
        // {
        //   path: '/system/menu',
        //   name: 'Menu',
        //   component: () => import('@/views/system/menu'),
        //   meta: { title: '菜单管理', keepAlive: false }
        // }
      ]
    },
  // account
  {
    path: '/account',
    component: RouteView,
    redirect: '/account/settings',
    name: 'account',
    meta: { title: '个人页', icon: 'user', keepAlive: true, permission: [ 'user' ] },
    children: [
      // {
      //   path: '/account/center',
      //   name: 'center',
      //   component: () => import('@/views/account/center'),
      //   meta: { title: '个人中心', keepAlive: true, savePageAlive: true, permission: [ 'user' ] }
      // },
      {
        path: '/account/settings',
        name: 'settings',
        component: () => import('@/views/account/settings/Index'),
        meta: { title: '个人设置', keepAlive: true, savePageAlive: true, hideHeader: true, permission: [ 'user' ] },
        redirect: '/account/settings/security',
        hideChildrenInMenu: true,
        children: [
          {
            path: '/account/settings/base',
            name: 'BaseSettings',
            component: () => import('@/views/account/settings/BaseSetting'),
            meta: { title: '基本设置', keepAlive: true, savePageAlive: true, hidden: true, permission: [ 'user' ] }
          },
          {
            path: '/account/settings/security',
            name: 'SecuritySettings',
            component: () => import('@/views/account/settings/Security'),
            meta: { title: '安全设置', hidden: true, keepAlive: true, savePageAlive: true, permission: [ 'user' ] }
          },
          {
            path: '/account/settings/custom',
            name: 'CustomSettings',
            component: () => import('@/views/account/settings/Custom'),
            meta: { title: '个性化设置', hidden: true, keepAlive: true, savePageAlive: true, permission: [ 'user' ] }
          },
          {
            path: '/account/settings/binding',
            name: 'BindingSettings',
            component: () => import('@/views/account/settings/Binding'),
            meta: { title: '账户绑定', hidden: true, keepAlive: true, savePageAlive: true, permission: [ 'user' ] }
          },
          {
            path: '/account/settings/notification',
            name: 'NotificationSettings',
            component: () => import('@/views/account/settings/Notification'),
            meta: { title: '新消息通知', hidden: true, keepAlive: true, savePageAlive: true, permission: [ 'user' ] }
          }
        ]
      },
      {
        path: '/account/download',
        name: "download",
        meta: { title: '下载中心', keepAlive: true, permission: [ 'user' ] },
        component: () => import('@/views/account/download/index')
      }
    ]
  },
    // 任务日志
    {
      path: '/job',
      name: 'job',
      redirect: '/monitor/job',
      component: RouteView,
      meta: { title: '定时任务', keepAlive: true, icon: 'control' },
      children: [{
        path: '/job/log',
        name: 'JobLog',
        component: () => import('@/views/monitor/job/log'),
        meta: { title: '调度日志', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/dict',
      name: 'dict',
      redirect: '/system/dict',
      component: RouteView,
      meta: { title: '字典管理', keepAlive: true, icon: 'control' },
      children: [{
        path: 'type/data/:dictId(\\d+)',
        name: 'Data',
        component: () => import('@/views/system/dict/data'),
        meta: { title: '字典子项', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/gen',
      name: 'gen',
      redirect: '/tool/gen',
      component: RouteView,
      meta: { title: '代码生成', keepAlive: true, icon: 'control' },
      children: [{
        path: 'edit/:tableId(\\d+)',
        name: 'GenEdit',
        component: () => import('@/views/tool/gen/components/GenEdit'),
        meta: { title: '数据表编辑', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/lookup',
      name: 'lookup',
      redirect: '/system/lookup',
      component: RouteView,
      meta: { title: '快码管理', keepAlive: true, icon: 'control' },
      children: [{
        path: 'look-up-detail',
        name: 'look-up-detail',
        component: () => import('@/views/system/lookup/look-up-detail'),
        meta: { title: '快码子项', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/materialCategory',
      name: 'materialCategory',
      redirect: '/mdm/matter/materialCategory',
      component: RouteView,
      meta: { title: '物料类别', keepAlive: true, icon: 'control' },
      children: [{
        path: 'material-category-category',
        name: 'material-category-category',
        component: () => import('@/views/mdm/matter/materialCategory/material-category-category'),
        meta: { title: '类别代码', keepAlive: true, savePageAlive: true },
        hidden: true
      },
      {
        path: 'material-category-distribution',
        name: 'material-category-distribution',
        component: () => import('@/views/mdm/matter/materialCategory/material-category-distribution'),
        meta: { title: '物料类别分配', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/materialTemplate',
      name: 'materialTemplate',
      redirect: '/mdm/matter/materialTemplate',
      component: RouteView,
      meta: { title: '物料模板', keepAlive: true, icon: 'control' },
      children: [{
        path: 'material-template-detail',
        name: 'material-template-detail',
        component: () => import('@/views/mdm/matter/materialTemplate/material-template-detail'),
        meta: { title: '物料模板详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/materialInventory',
      name: 'materialInventory',
      redirect: '/mdm/matter/materialInventory',
      component: RouteView,
      meta: { title: '物料清单', keepAlive: true, icon: 'control' },
      children: [{
        path: 'material-inventory-detail',
        name: 'material-inventory-detail',
        component: () => import('@/views/mdm/matter/materialInventory/material-inventory-detail'),
        meta: { title: '物料清单详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/workCalendar',
      name: 'workCalendar',
      redirect: '/mes/calendar/workCalendar',
      component: RouteView,
      meta: { title: '工作日历', keepAlive: true, icon: 'control' },
      children: [{
        path: 'work-calendar-detail',
        name: 'work-calendar-detail',
        component: () => import('@/views/mes/calendar/workCalendar/work-calendar-detail'),
        meta: { title: '工作日历详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/mrpPlanName',
      name: 'mrpPlanName',
      redirect: '/scp/planSetting/mrpPlanName',
      component: RouteView,
      meta: { title: 'MRP计划名称', keepAlive: true, icon: 'control' },
      children: [{
        path: 'mrp-plan-name-detail',
        name: 'mrp-plan-name-detail',
        component: () => import('@/views/scp/planSetting/mrpPlanName/mrp-plan-name-detail'),
        meta: { title: 'MRP计划名称详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/schedulingWorkbench',
      name: 'schedulingWorkbench',
      redirect: '/scp/productionScheduling/schedulingWorkbench',
      component: RouteView,
      meta: { title: '排产工作台', keepAlive: true, icon: 'control' },
      children: [{
        path: 'ProductionLineCapacity/:id',
        name: 'ProductionLineCapacity',
        component: () => import('@/views/scp/productionScheduling/schedulingWorkbench/components/ProductionLineCapacity'),
        meta: { title: '产线产能负荷', keepAlive: true, savePageAlive: true },
        hidden: true
      },
      {
        path: 'productionProcessesLoad/:id',
        name: 'productionProcessesLoad',
        component: () => import('@/views/scp/productionScheduling/schedulingWorkbench/components/productionProcessesLoad'),
        meta: { title: '工序产能负荷', keepAlive: true, savePageAlive: true },
        hidden: true
      }
    ]
    },
    {
      path: '/callMaterialManage',
      name: 'callMaterialManage',
      redirect: '/scp/factoryCallMaterial/callMaterialManage',
      component: RouteView,
      meta: { title: '叫料单管理', keepAlive: true, icon: 'control' },
      children: [{
        path: 'call-material-manage-detail',
        name: 'call-material-manage-detail',
        component: () => import('@/views/scp/factoryCallMaterial/callMaterialManage/call-material-manage-detail'),
        meta: { title: '叫料单管理详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/shipmentForecastManagement',
      name: 'shipmentForecastManagement',
      redirect: '/scp/producingAndMarketing/shipmentForecast',
      component: RouteView,
      meta: { title: '发货预测编辑', keepAlive: true, icon: 'control' },
      children: [{
        path: 'editPage/:id?',
        name: 'editPage',
        component: () => import('@/views/scp/producingAndMarketing/shipmentForecast/shipmentForecastManagement/editPage'),
        meta: { title: '发货预测编辑', keepAlive: true, savePageAlive: true },
        hidden: true
      },
      {
        path: 'detail/:name?/:version?',
        name: 'detail',
        component: () => import('@/views/scp/producingAndMarketing/shipmentForecast/shipmentForecastManagement/detail'),
        meta: { title: '发货预测汇总', keepAlive: true, savePageAlive: true },
        hidden: true
      },
      {
        path: 'comparison/:id?',
        name: 'comparison',
        component: () => import('@/views/scp/producingAndMarketing/shipmentForecast/shipmentForecastManagement/comparison'),
        meta: { title: '发货预测查询-明细', keepAlive: true, savePageAlive: true },
        hidden: true
      },
      {
        path: 'runningStatus/:id?',
        name: 'runningStatus',
        component: () => import('@/views/scp/producingAndMarketing/shipmentForecast/shipmentForecastManagement/runningStatus'),
        meta: { title: '运行阶段状态', keepAlive: true, savePageAlive: true },
        hidden: true
      },
      {
        path: 'earningReport/:id?',
        name: 'earningReport',
        component: () => import('@/views/scp/producingAndMarketing/shipmentForecast/shipmentForecastManagement/earningReport'),
        meta: { title: '滚动业绩报表', keepAlive: true, savePageAlive: true },
        hidden: true
      },
      {
        path: 'monthsDetail/:name?/:version?/:id?/:month?/:demandDepartment?',
        name: 'monthsDetail',
        component: () => import('@/views/scp/producingAndMarketing/shipmentForecast/shipmentForecastManagement/monthsDetail'),
        meta: { title: '发货预测明细', keepAlive: true, savePageAlive: true },
        hidden: true
      }
    ]
    },
    {
      path: '/salesForecast',
      name: 'salesForecast',
      redirect: '/scp/salesForecast/workDesk',
      component: RouteView,
      meta: { title: '销售货预测编辑', keepAlive: true, icon: 'control' },
      children: [{
        path: 'detail/:forecastName?/:versionCode?/:versionDescription?',
        name: 'detail',
        component: () => import('@/views/scp/producingAndMarketing/salesForecast/salesForecastWorkDesk/detail'),
        meta: { title: '销售预测详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/approval-process',
      name: 'approval-process',
      redirect: '/approval/approval-process',
      component: RouteView,
      meta: { title: '审批流程', keepAlive: true, icon: 'control' },
      children: [
        {
        path: 'approval-process-detail',
        name: 'approval-process-detail',
        component: () => import('@/views/approval/approval-process/approval-process-detail'),
        meta: { title: '审批流程详情', keepAlive: true, savePageAlive: true },
        hidden: true
      },
      {
        path: 'approval-inventory-adjectment',
        name: 'approval-inventory-adjectment',
        component: () => import('@/views/approval/approval-process/approval-inventory-adjectment'),
        meta: { title: '审批流程详情', keepAlive: true, savePageAlive: true },
        hidden: true
      },
        {
          path: 'work-order-change-process-detail',
          name: 'WorkOrderChangeProcessDetail',
          component: () => import('@/views/approval/approval-process/work-order-change-process-detail'),
          meta: { title: '审批流程详情', keepAlive: true, savePageAlive: true },
          hidden: true
        }
      ]
    },
    {
      path: '/shipmentForecastSettings',
      name: 'shipmentForecastSettings',
      redirect: '/scp/generalParameterSettings/shipmentForecastSettings',
      component: RouteView,
      meta: { title: '发货预测基础数据', keepAlive: true, icon: 'control' },
      children: [{
        path: 'versionDetail',
        name: 'versionDetail',
        component: () => import('@/views/scp/producingAndMarketing/generalParameterSettings/shipmentForecastSettings/versionDetail'),
        meta: { title: '基础数据详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/new-product-forecast',
      name: 'new-product-forecast',
      redirect: '/scp/new-product-forecast/work-desk',
      component: RouteView,
      meta: { title: '新品预测编辑', keepAlive: true, icon: 'control' },
      children: [{
        path: 'detail/:forecastName?/:versionCode?/:versionDescription?',
        name: 'detail',
        component: () => import('@/views/scp/producingAndMarketing/new-product-forecast/new-product-forecast-workdesk/detail.vue'),
        meta: { title: '新品预测详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/missing-forecast',
      name: 'missing-forecast',
      redirect: '/scp/missing-forecast/work-desk',
      component: RouteView,
      meta: { title: '预测缺失编辑', keepAlive: true, icon: 'control' },
      children: [{
        path: 'detail/:forecastName?/:versionCode?/:versionDescription?',
        name: 'detail',
        component: () => import('@/views/scp/producingAndMarketing/missing-forecast/detail.vue'),
        meta: { title: '预测缺失详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/product-source-rules',
      name: 'product-source-rules',
      redirect: '/mps/mps-basic-info/product-source-rules',
      component: RouteView,
      meta: { title: '产品规则来源', keepAlive: true, icon: 'control' },
      children: [{
        path: 'detail',
        name: 'detail',
        component: () => import('@/views/mps/mps-basic-info/product-source-rules/detail.vue'),
        meta: { title: '成品规则来源详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/supplier-capacity',
      name: 'supplier-capacity',
      redirect: '/scp/generalParameterSettings/supplier-capacity',
      component: RouteView,
      meta: { title: '供应商产能编辑', keepAlive: true, icon: 'control' },
      children: [{
        path: 'detail',
        name: 'detail',
        component: () => import('@/views/scp/producingAndMarketing/generalParameterSettings/supplier-capacity/detail.vue'),
        meta: { title: '供应商产能详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/safety-stock-ratio',
      name: 'safety-stock-ratio',
      redirect: '/scp/generalParameterSettings/safety-stock-ratio',
      component: RouteView,
      meta: { title: '安全库存比例', keepAlive: true, icon: 'control' },
      children: [{
        path: 'detail',
        name: 'detail',
        component: () => import('@/views/scp/producingAndMarketing/generalParameterSettings/safety-stock-ratio/detail.vue'),
        meta: { title: '安全库存比例详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/basic-info-index',
      name: 'basic-info-index',
      redirect: '/scp/mps-basic-info/basic-info-index',
      component: RouteView,
      meta: { title: 'MPS基础数据', keepAlive: true, icon: 'control' },
      children: [{
        path: 'detail',
        name: 'detail',
        component: () => import('@/views/mps/mps-basic-info/basic-info-index/detail.vue'),
        meta: { title: 'MPS基础数据详情', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/mps-plan-execution',
      name: 'mps-plan-execution',
      redirect: '/mps/mps-result/mps-plan-execution',
      component: RouteView,
      meta: { title: '计划执行', keepAlive: true, icon: 'control' },
      children: [{
        path: 'result/:id?/:description?/:versionCode?',
        name: 'result',
        component: () => import('@/views/mps/mps-result/mps-plan-execution/result.vue'),
        meta: { title: '计划执行结果', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/monthly-plan',
      name: 'monthly-plan',
      redirect: '/scp/producingAndMarketing/monthly-plan',
      component: RouteView,
      meta: { title: '月度计划', keepAlive: true, icon: 'control' },
      children: [{
        path: 'editPage/:id?',
        name: 'editPage',
        component: () => import('@/views/scp/producingAndMarketing/monthly-plan/editPage.vue'),
        meta: { title: '月度计划编辑', keepAlive: true, savePageAlive: true },
        hidden: false
      },
      {
        path: 'detail/:name?/:version?/:id?',
        name: 'detail',
        component: () => import('@/views/scp/producingAndMarketing/monthly-plan/detail.vue'),
        meta: { title: '月度计划详情', keepAlive: true, savePageAlive: true },
        hidden: true
      },
      {
        path: 'capacityLoadPage/:name?/:version?/:id?',
        name: 'capacityLoadPage',
        component: () => import('@/views/scp/producingAndMarketing/monthly-plan/capacityLoadPage.vue'),
        meta: { title: '产能负荷', keepAlive: true, savePageAlive: true },
        hidden: true
      },
      {
        path: 'productionDemandPage/:name?/:version?/:id?',
        name: 'productionDemandPage',
        component: () => import('@/views/scp/producingAndMarketing/monthly-plan/productionDemandPage.vue'),
        meta: { title: '生产需求', keepAlive: true, savePageAlive: true },
        hidden: true
      }
    ]
    },
    {
      path: '/mps-work-desk',
      name: 'mps-work-desk',
      redirect: '/mps/mps-manage/mps-work-desk',
      component: RouteView,
      meta: { title: '工作台', keepAlive: true, icon: 'control' },
      children: [{
        path: 'detail/:id?',
        name: 'detail',
        component: () => import('@/views/mps/mps-manage/mps-work-desk/detail.vue'),
        meta: { title: '工作台详细页面', keepAlive: true, savePageAlive: true },
        hidden: false
      }]
    },
    {
      path: '/mps-Inspection-requirements',
      name: 'mps-Inspection-requirements',
      redirect: '/mps/mps-result/mps-Inspection-requirements',
      component: RouteView,
      meta: { title: '报检需求', keepAlive: true, icon: 'control' },
      children: [{
        path: 'inspectionAdjustment/:id?',
        name: 'inspectionAdjustment',
        component: () => import('@/views/mps/mps-result/mps-Inspection-requirements/inspectionAdjustment.vue'),
        meta: { title: '报检调整页面', keepAlive: true, savePageAlive: true },
        hidden: false
      }]
    },
    {
      path: '/runCallMaterialPlan',
      name: 'runCallMaterialPlan',
      redirect: '/scp/factoryCallMaterial/runCallMaterialPlan',
      component: RouteView,
      meta: { title: '运行叫料计划', keepAlive: true, icon: 'control' },
      children: [{
        path: 'call-material-plan-list-detail',
        name: 'Call-material-plan-list',
        component: () => import('@/views/scp/factoryCallMaterial/call-material-plan-list'),
        meta: { title: '计划请求列表', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/operationWorkAnalysis',
      name: 'operationWorkAnalysis',
      redirect: '/scp/workOrderSetCall/operationWorkAnalysis',
      component: RouteView,
      meta: { title: '运行工单齐套分析', keepAlive: true, icon: 'control' },
      children: [{
        path: 'call-material-plan-list-detail',
        name: 'Call-material-plan-list',
        component: () => import('@/views/scp/factoryCallMaterial/call-material-plan-list'),
        meta: { title: '计划请求列表', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
    {
      path: '/working-mrp-plan',
      name: 'working-mrp-plan',
      redirect: '/scp/reserve-goods-plan/working-mrp-plan',
      component: RouteView,
      meta: { title: '运行MRP计划', keepAlive: true, icon: 'control' },
      children: [{
        path: 'call-material-plan-list-detail',
        name: 'Call-material-plan-list',
        component: () => import('@/views/scp/factoryCallMaterial/call-material-plan-list'),
        meta: { title: '计划请求列表', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
      {
        path: '/materialReservationList',
        name: 'materialReservationList',
        redirect: '/scp/materialReservationManagement/materialReservationList',
        component: RouteView,
        meta: { title: '材料预约列表', keepAlive: true, icon: 'control' },
        children: [{
          path: 'materialReservationDetail',
          name: 'MaterialReservationDetail',
          component: () => import('@/views/scp/materialReservationManagement/materialReservationList/materialReservationDetail.vue'),
          meta: { title: '材料预约详情', keepAlive: true, savePageAlive: true },
          hidden: true
        }]
      },
    {
      path: '/data-collection',
      name: 'data-collection',
      redirect: '/scp/producingAndMarketing/data-collection',
      component: RouteView,
      meta: { title: '数据收集', keepAlive: true, icon: 'control' },
      children: [{
        path: 'call-material-plan-list-detail',
        name: 'Call-material-plan-list',
        component: () => import('@/views/scp/factoryCallMaterial/call-material-plan-list'),
        meta: { title: '计划请求列表', keepAlive: true, savePageAlive: true },
        hidden: true
      }]
    },
      {
        path: '/plan-completion-rate',
        name: 'plan-completion-rate',
        redirect: '/report/plan-completion-rate',
        component: RouteView,
        meta: { title: '日计划完成率报表', keepAlive: true, icon: 'control' },
        children: [{
          path: 'reportDetail/:date',
          name: 'reportDetail',
          component: () => import('@/views/report/components/index'),
          meta: { title: '报表明细', keepAlive: true, savePageAlive: true },
          hidden: true
        }]
      },
      {
        path: '/plan-delivery-rate',
        name: 'plan-delivery-rate',
        redirect: '/report/plan-delivery-rate',
        component: RouteView,
        meta: { title: '计划达交率报表', keepAlive: true, icon: 'control' },
        children: [{
          path: 'reportDetail/:date',
          name: 'reportDetail',
          component: () => import('@/views/report/components/index'),
          meta: { title: '报表明细', keepAlive: true, savePageAlive: true },
          hidden: true
        }]
      },
    // {
    //   path: 'reportDetail/:date',
    //   name: 'reportDetail',
    //   component: () => import('@/views/report/components/index'),
    //   meta: { title: '报表明细', keepAlive: true },
    //   hidden: true
    // },
      {
        path: '/estate-daily-plan-analysis-report',
        name: 'estate-daily-plan-analysis-report',
        redirect: '/report/estate-daily-plan-analysis-report',
        component: RouteView,
        meta: { title: '每日分析报表', keepAlive: true, icon: 'control' },
        children: [{
          path: 'analysisReportDetail/:id',
          name: 'analysisReportDetail',
          component: () => import('@/views/report/estate-daily-plan-analysis-report/components/detail'),
          meta: { title: '实际完成明细', keepAlive: true, savePageAlive: true },
          hidden: true
        }]
      },
      {
        path: '/standardProcessNewEditPage',
        name: 'StandardProcessNewEditPage',
        meta: { title: '编辑工艺路线', keepAlive: true },
        hidden: true,
        component: RouteView,
        children: [{
          path: 'standardProcessNewEdit/:id',
          name: 'standardProcessNewEdit',
          component: () => import('@/views/mes/basedata/standardProcessNew/standard-process-new-edit.vue'),
          meta: { title: '编辑工艺路线', keepAlive: true, savePageAlive: true },
          hidden: true
        }]
      },
      {
        path: '/standardProcessNewDetailPage',
        name: 'StandardProcessNewDetailPage',
        meta: { title: '工艺路线详情', keepAlive: true },
        hidden: true,
        component: RouteView,
        children: [{
          path: 'standardProcessNewDetail/:id',
          name: 'standardProcessNewDetail',
          component: () => import('@/views/mes/basedata/standardProcessNew/standard-process-new-detail.vue'),
          meta: { title: '工艺路线详情', keepAlive: true, savePageAlive: true },
          hidden: true
        }]
      }
      // {
      //   path: 'analysisReportDetail/:id',
      //   name: 'analysisReportDetail',
      //   component: () => import('@/views/report/estate-daily-plan-analysis-report/components/detail'),
      //   meta: { title: '实际完成明细', keepAlive: true },
      //   hidden: true
      // }
  ]
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult')
      },
      {
        path: 'recover',
        name: 'recover',
        component: undefined
      }
    ]
  },

  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }

]
